var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"calendar-radio\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Cdb-a-radio class=\"calendar-radio-state\" selected=\"$ctrl.selected\"\u003E\u003C\u002Fdb-a-radio\u003E\u003Cdiv class=\"calendar-radio-name\" ng-bind=\"$ctrl.name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/application/component/calendar-radio/calendar-radio.tpl.pug
// module id = V164
// module chunks = 0